import { useTranslation } from 'react-i18next';
import { PersonaCard, type PersonaCardAction } from '@/entities/persona';
import type { PersonaListBlockProps } from './PersonaListBlock.types';

export const PersonaListBlock = ({
  persona,
  onPersonaClick,
  onStartConversation,
  isCurrentPersonaSelected = false,
  isStartConversationDisabled = false,
  readOnly = false,
}: PersonaListBlockProps) => {
  const { t } = useTranslation('audiences');
  const name = persona.personaTitle || persona.segmentName;

  const actions: PersonaCardAction[] = [
    {
      label: t('audienceFlowWidget.personaListBlock.viewDetails'),
      onSelect: () => onPersonaClick(persona),
    },
    ...(readOnly
      ? []
      : [
          {
            label: t('audienceFlowWidget.personaListBlock.startConversation'),
            onSelect: () => onStartConversation(persona),
            disabled: isCurrentPersonaSelected || isStartConversationDisabled,
          },
        ]),
  ];

  return (
    <PersonaCard
      name={name}
      age={persona.demographicsData?.data.age}
      title={persona.segmentName ?? ''}
      tags={persona.demographicsData?.data.interests || []}
      description={persona.personaBrief ?? ''}
      photoAssetId={persona.photoAssetId}
      mouseOverAssetId={persona.mouseOverAssetId}
      onClick={() => onPersonaClick(persona)}
      actions={actions}
    />
  );
};
